import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { FilterInputs } from '@repo/ui/components'
import { flexRender, Header } from '@tanstack/react-table'
import { CSSProperties } from 'react'

import { TableHead } from '../../ui'
import { getCommonPinningStyles } from '../pinning/pinning.tsx'

export const DraggableTableHeader = <TData, TValue>({
  header,
}: {
  header: Header<TData, TValue>
}) => {
  const { attributes, isDragging, listeners, setNodeRef, transform } = useSortable({
    id: header.column.id,
  })

  const style: CSSProperties = {
    opacity: isDragging ? 0.8 : 1,
    position: 'relative',
    transform: CSS.Translate.toString(transform), // translate instead of transform to avoid squishing
    transition: 'width transform 0.2s ease-in-out',
    whiteSpace: 'nowrap',
    width: header.column.getSize(),
    zIndex: isDragging ? 1 : 0,
  }

  return (
    <TableHead
      className={'bg-[#eaf0f6]'}
      ref={setNodeRef}
      style={{ ...style, ...getCommonPinningStyles(header.column) }}
    >
      <div className={'group flex h-24 flex-col'}>
        <div className={'flex h-12 items-center justify-between'}>
          {header.isPlaceholder
            ? null
            : flexRender(header.column.columnDef.header, header.getContext())}
          <button
            className={'opacity-0 transition-opacity duration-300 group-hover:opacity-100'}
            {...attributes}
            {...listeners}
          >
            🟰
          </button>
        </div>
        {header.column.getCanFilter() ? (
          <div className={'flex h-12 items-center justify-center'}>
            <FilterInputs column={header.column} />
          </div>
        ) : null}
      </div>
    </TableHead>
  )
}
